import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 更新海运提单属性信息
export function updateProperties(params, data) {
  return request({
    url: URL.seaExport.updateProperties,
    method: 'post',
    params,
    data
  })
}

// 完成补料
export function completeTheFeed(params) {
  return request({
    url: URL.seaExport.completeTheFeed,
    method: 'post',
    params
  })
}

// 保存海运提单
export function saveSeaCargoDoc(data) {
  return request({
    url: URL.seaExport.saveSeaCargoDoc,
    method: 'post',
    data
  })
}

// 根据主键获取海运提单
export function getSeaCargoDoc(params) {
  return request({
    url: URL.seaExport.getSeaCargoDoc,
    method: 'get',
    params
  })
}

// 确认提单
export function affirmSeaCargoDocFunc(data) {
  return request({
    url: URL.seaExport.affirmSeaCargoDoc,
    method: 'post',
    data
  })
}

// 根据主键获取海运提单
export function getSeaCargoDocByJobUuid(params) {
  return request({
    url: URL.seaExport.getSeaCargoDocByJobUuid,
    method: 'get',
    params
  })
}

export function executeRuleEngine(params) {
  return request({
    url: URL.seaExport.executeRuleEngine,
    method: 'get',
    params
  })
}

// 根据JobUuid获取海运MBL提单
export function getSeaMblByJobUuid(params) {
  return request({
    url: URL.seaExport.getSeaMblByJobUuid,
    method: 'get',
    params
  })
}

// 投保
export function toInsure(data) {
  return request({
    url: URL.seaExport.toInsure,
    method: 'post',
    data
  })
}

// 获取提单EDI箱封信息列表
export function getEdiContainerList(params) {
  return request({
    url: URL.seaExport.getEdiContainerList,
    method: 'get',
    params
  })
}

export function queryEdiContainerDataFunc(params) {
  return request({
    url: URL.seaExport.queryEdiContainerDataUrl,
    method: 'get',
    params
  })
}

// 获取反恐舱单地址信息列表
export function getAfrAddressList(params) {
  return request({
    url: URL.seaExport.getAfrAddressList,
    method: 'get',
    params
  })
}

// 获取HBL保函信息
export function getGuaranteeStateInfo(data) {
  return request({
    url: URL.seaExport.getGuaranteeStateInfo,
    method: 'POST',
    data
  })
}

// 获取ens 申报信息
export function getEnsByCargoDoc(params) {
  return request({
    url: URL.seaExport.getEnsByCargoDoc,
    method: 'get',
    params
  })
}
// 获取ens 货物信息
export function getEnsCargoInfoByCargoDoc(params) {
  return request({
    url: URL.seaExport.getEnsCargoInfoByCargoDoc,
    method: 'get',
    params
  })
}

// 获取HBL提单运费列表
export function getFreightCharges(params) {
  return request({
    url: URL.seaExport.getFreightCharges,
    method: 'get',
    params
  })
}

// 加载提单相关信息
export function loadCargoDocRelated(params) {
  return request({
    url: URL.seaExport.loadCargoDocRelated,
    method: 'get',
    params
  })
}

// 获取对单地址
export function getCfmAddress(params) {
  return request({
    url: URL.seaExport.getCfmAddress,
    method: 'get',
    params
  })
}
// 获取AMS回执信息
export function queryAMSReceiptInfoByAmsNo(params) {
  return request({
    url: URL.seaExport.queryAMSReceiptInfoByAmsNo,
    method: 'get',
    params
  })
}
// 获取AMS回执信息
export function queryTradetechAMSReceiptInfo(data) {
  return request({
    url: URL.seaExport.queryTradetechAMSReceiptInfo,
    method: 'post',
    data
  })
}

// 发送ISF
export function sendISF(data) {
  return request({
    url: URL.seaExport.sendISF,
    method: 'post',
    data
  })
}

// 电放或者正本打印/解锁
export function surrendered(body) {
  return request({
    url: URL.seaExport.surrendered,
    method: 'get',
    params: body
  })
}

// 触发Sop节点
export function postRemotingTracking(body) {
  return request({
    url: URL.seaExport.postRemotingTracking,
    method: 'get',
    params: body
  })
}

// HBL自动放单
export function autoAuditSingleReleaseHBL(body) {
  return request({
    url: URL.seaExport.autoAuditSingleReleaseHBL,
    method: 'put',
    params: body
  })
}

// 查看反恐舱单发送状态
export function querySendStatus(params) {
  return request({
    url: URL.seaExport.querySendStatus,
    method: 'get',
    params
  })
}

export function importAmsExcel(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.amsImportExcel,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}

// 发送AMS
export function sendAMS(data) {
  return request({
    url: URL.seaExport.sendAMS,
    method: 'post',
    data
  })
}

// 得到AMS
export function getAMS(data) {
  return request({
    url: URL.seaExport.getAMS,
    method: 'post',
    data
  })
}

// 通过获取的xml发送AMS
export function sendAMSXml(data) {
  return request({
    url: URL.seaExport.sendAMSXml,
    method: 'post',
    data
  })
}

// 得到AMS
export function getISF(data) {
  return request({
    url: URL.seaExport.getISF,
    method: 'post',
    data
  })
}

// 通过获取的xml发送ISF
export function sendISFXml(data) {
  return request({
    url: URL.seaExport.sendISFXml,
    method: 'post',
    data
  })
}

// 得到ENS
export function getENS(data) {
  return request({
    url: URL.seaExport.getENS,
    method: 'post',
    data
  })
}

// 通过获取的xml发送ENS
export function sendENSXml(data) {
  return request({
    url: URL.seaExport.sendENSXml,
    method: 'post',
    data
  })
}
// 校验ENS是否可发送
export function checkSendEns(data) {
  return request({
    url: URL.seaExport.checkSendEns,
    method: 'post',
    data
  })
}

// 得到AFR
export function getAFR(data) {
  return request({
    url: URL.seaExport.getAFR,
    method: 'post',
    data
  })
}
export function importAfrExcel(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.afrImportExcel,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}

// 发送提单确认
export function xhqUpdateBillInfo(params) {
  return request({
    url: URL.seaExport.xhqUpdateBillInfo,
    method: 'get',
    params
  })
}

// 发送提单确认
export function toXhqUpdateLclBillInfo(params) {
  return request({
    url: URL.seaExport.xhqUpdateLclBillInfo,
    method: 'get',
    params
  })
}

// 查询对单日志
export function xhqQueryCheckTheBLLog(params) {
  return request({
    url: URL.seaExport.xhqQueryCheckTheBLLog,
    method: 'get',
    params
  })
}

// 查询邀请对单地址
export function xhqGetCfmAddress(params) {
  return request({
    url: URL.seaExport.xhqGetCfmAddress,
    method: 'get',
    params
  })
}

// 发送客户文件
export function xhqSendCustomerFiles(data) {
  return request({
    url: URL.seaExport.xhqSendCustomerFiles,
    method: 'post',
    data
  })
}

export function xhqGetContainerLclList(data) {
  return request({
    url: URL.seaExport.xhqGetContainerLclList,
    method: 'post',
    data
  })
}
// 申请放单
export function requestRelease(data) {
  return request({
    url: URL.seaExport.requestRelease,
    method: 'post',
    data
  })
}
// 取消申请放单
export function cancelRequestRelease(data) {
  return request({
    url: URL.seaExport.cancelRequestRelease,
    method: 'post',
    data
  })
}

// 信号旗海外代理反馈-查询
export function xhqQueryOverseasAgentFeedback(params) {
  return request({
    url: URL.seaExport.xhqQueryOverseasAgentFeedback,
    method: 'get',
    params
  })
}

// 信号旗海外代理反馈-接受修改
export function xhqAcceptOverseasAgentFeedback(data) {
  return request({
    url: URL.seaExport.xhqAcceptOverseasAgentFeedback,
    method: 'post',
    data
  })
}

// 信号旗海外代理反馈-不接受
export function xhqNotAcceptOverseasAgentFeedback(data) {
  return request({
    url: URL.seaExport.xhqNotAcceptOverseasAgentFeedback,
    method: 'post',
    data
  })
}

// 信号旗海外代理反馈-查询条数
export function xhqQueryAgentFeedbackCount(params) {
  return request({
    url: URL.seaExport.xhqQueryAgentFeedbackCount,
    method: 'get',
    params
  })
}

// 劲升发送AMS接口
export function jsSendAms(data) {
  return request({
    url: URL.seaExport.jsSendAms,
    method: 'post',
    data
  })
}

// 劲升发送AMS校验接口
export function jsAmsValidation(params) {
  return request({
    url: URL.seaExport.jsAmsValidation,
    method: 'get',
    params
  })
}

// 劲升发送AMS接口
export function jsSendAci(data) {
  return request({
    url: URL.seaExport.jsSendAci,
    method: 'post',
    data
  })
}

// 劲升发送AMS接口
export function jsSendAfr(data) {
  return request({
    url: URL.seaExport.jsSendAfr,
    method: 'post',
    data
  })
}

// 劲升查看回执接口
export function jsViewReceipts(params) {
  return request({
    url: URL.seaExport.jsViewReceipts,
    method: 'get',
    params
  })
}

// ens查看回执接口
export function ensViewReceipts(params) {
  return request({
    url: URL.seaExport.ensViewReceipts,
    method: 'get',
    params
  })
}

// 完成补料
export function returnToBeConfirmedFunc(params) {
  return request({
    url: URL.seaExport.returnToBeConfirmedUrl,
    method: 'post',
    params
  })
}

// Aci导入接口
export function importAciExcel(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.aciImportExcel,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}

// Ens导入接口
export function importEnsExcel(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.ensImportExcel,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}

// 获取提单补充信息
export function getCargoDocExtend(data) {
  return request({
    url: URL.seaExport.getCargoDocExtend,
    method: 'post',
    data
  })
}

// 保存提单补充信息
export function saveCargoDocExtend(data) {
  return request({
    url: URL.seaExport.saveCargoDocExtend,
    method: 'post',
    data
  })
}

// 抄录发货人或收货人
export function copyShipperOrConsignee(params) {
  return request({
    url: URL.seaExport.copyShipperOrConsignee,
    method: 'post',
    params
  })
}

// 查询可抄录业务
export function getByCondition(data) {
  return request({
    url: URL.seaExport.getByCondition,
    method: 'post',
    data
  })
}

// ISF5导入接口
export function importIsf5Excel(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.isf5ImportExcel,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}

// ISF10导入接口
export function importIsf10Excel(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.isf10ImportExcel,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}
// eManifest导入接口
export function importEManifestExcel(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.eManifestImportExcel,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}

export function jydSendJobInfo(data) {
  return request({
    url: URL.seaExport.jydSendJobInfo,
    method: 'post',
    data
  })
}
